import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { StandingOrdersClient } from "@/features/standingOrders/StandingOrdersClient";
import { listStandingOrders, standingOrderKeys } from "@/features/standingOrders/standingOrders.api";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

// Transport → Vaste orders (docs/tms-vaste-orders.md): what comes back every week on the same days. Order entry:
// tms_orders to read, tms_orders_write to keep them.
export const Route = createFileRoute("/_shell/standing-orders/")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_orders") && !hasModule(context.session, "tms_orders_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: StandingOrdersScreen,
});

function StandingOrdersScreen() {
  const { session } = Route.useRouteContext();
  const query = useQuery({ queryKey: standingOrderKeys.list, queryFn: listStandingOrders });
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Standing Orders">
      <StandingOrdersClient
        rows={query.data ?? []}
        userId={session.userId}
        canWrite={hasModule(session, "tms_orders_write")}
        isLoading={query.isLoading}
      />
    </div>
  );
}
